// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5977) return "js/chunk.npm-async-core-js.84310f3c.js";
	if (chunkId === 2683) return "js/chunk.npm-async-@radix-ui.68954531.js";
	if (chunkId === 3910) return "js/chunk.3910.2e26d8f0.js";
	if (chunkId === 3356) return "js/chunk.3356.35ef8efa.js";
	if (chunkId === 8298) return "js/chunk.8298.b98bc6b9.js";
	if (chunkId === 3316) return "js/chunk.npm-async-lucide-react.90d04df3.js";
	if (chunkId === 4850) return "js/chunk.npm-async-embla-carousel.5a4943ce.js";
	if (chunkId === 7326) return "js/chunk.npm-async-embla-carousel-reactive-utils.fa8c3a21.js";
	if (chunkId === 320) return "js/chunk.npm-async-embla-carousel-react.4e21d172.js";
	if (chunkId === 8768) return "js/chunk.8768.319edb43.js";
	if (chunkId === 6091) return "js/chunk.6091.cb1e658a.js";
	if (chunkId === 9533) return "js/chunk.npm-async-@tanstack.3e3e10f3.js";
	if (chunkId === 9333) return "js/chunk.9333.73cea3d4.js";
	if (chunkId === 9331) return "js/chunk.9331.1521a1a2.js";
	if (chunkId === 4889) return "js/chunk.4889.98cce2e9.js";
	if (chunkId === 4797) return "js/chunk.npm-async-zod.7a642971.js";
	if (chunkId === 2647) return "js/chunk.2647.9251fefe.js";
	if (chunkId === 2193) return "js/chunk.npm-async-@atlaskit.fbecb70a.js";
	if (chunkId === 8673) return "js/chunk.npm-async-react-i18next.1ded69c0.js";
	if (chunkId === 7038) return "js/chunk.npm-async-@babel.00203621.js";
	if (chunkId === 8853) return "js/chunk.npm-async-@emotion.fbe2e39f.js";
	if (chunkId === 3404) return "js/chunk.npm-async-stylis.51b8ad28.js";
	if (chunkId === 2565) return "js/chunk.npm-async-@lit.5ea9e496.js";
	if (chunkId === 921) return "js/chunk.npm-async-lit.7df7aa8a.js";
	if (chunkId === 4117) return "js/chunk.npm-async-bind-event-listener.0a19afbb.js";
	if (chunkId === 7102) return "js/chunk.npm-async-@toeverything.dfe24099.js";
	if (chunkId === 9131) return "js/chunk.npm-async-html-parse-stringify.fdbdd717.js";
	if (chunkId === 4259) return "js/chunk.npm-async-debug.1fc9af62.js";
	if (chunkId === 427) return "js/chunk.npm-async-@vanilla-extract.08105d11.js";
	if (chunkId === 4261) return "js/chunk.npm-async-lit-html.fb5a9e32.js";
	if (chunkId === 5927) return "js/chunk.npm-async-i18next.754a8de3.js";
	if (chunkId === 2107) return "js/chunk.npm-async-@blocksuite.76459b0c.js";
	if (chunkId === 2628) return "js/chunk.npm-async-raf-schd.f7261152.js";
	if (chunkId === 2850) return "js/chunk.npm-async-ms.2dd65790.js";
	if (chunkId === 2422) return "js/chunk.npm-async-lottie-web.80a9cc67.js";
	if (chunkId === 2977) return "js/chunk.npm-async-lottie-react.eb085be1.js";
	if (chunkId === 6929) return "js/chunk.npm-async-dayjs.818da993.js";
	if (chunkId === 2905) return "js/chunk.2905.9546517b.js";
	if (chunkId === 5284) return "js/chunk.5284.13cfd95c.js";
	if (chunkId === 5589) return "js/chunk.5589.9a02be25.js";
	if (chunkId === 7071) return "js/chunk.7071.34f0e09b.js";
	if (chunkId === 5666) return "js/chunk.5666.b7f3c50b.js";
	if (chunkId === 5662) return "js/chunk.5662.14515ccc.js";
	if (chunkId === 8710) return "js/chunk.8710.8f6ecaf2.js";
	if (chunkId === 7350) return "js/chunk.7350.f49e530c.js";
	if (chunkId === 494) return "js/chunk.494.fd9b6614.js";
	if (chunkId === 6681) return "js/chunk.6681.bea3fd4e.js";
	if (chunkId === 135) return "js/chunk.135.27750c77.js";
	if (chunkId === 7635) return "js/chunk.7635.95873734.js";
	if (chunkId === 103) return "js/chunk.103.2cef6da0.js";
	if (chunkId === 906) return "js/chunk.906.f70ee7b2.js";
	if (chunkId === 3565) return "js/chunk.3565.dbc5b660.js";
	if (chunkId === 5353) return "js/chunk.5353.953c4247.js";
	if (chunkId === 8834) return "js/chunk.8834.e48c79b3.js";
	if (chunkId === 3809) return "js/chunk.3809.5d548677.js";
	if (chunkId === 4013) return "js/chunk.4013.4521e01f.js";
	// return url for filenames based on template
	return undefined;
};